import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function Press() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Company" title="Press" text={settings?.content_press} loading={!settings?.content_press} />;
}
